import React, { useMemo } from "react";

import SubResult from "../subResult";
//import Section from "components/sections/sections";
import PaginationButton from "../button/paginationButton";
import Container from "components/sections/container";
import usePagination from "hooks/usePagination";
import { getReports } from "utils/api/reports";
import { filterReport } from "utils/utils";

const ReportResultComponent = ({ results, meta }, ref) => {
  const limit = 6;
  const [currentPage, resultData, setCurrentPage] = usePagination(
    1,
    (start, pageSize, filters) => getReports(start, pageSize, filters),
    limit,
    results,
    filterReport(ref)
  );
  const createPaginationButtons = () => {
    const pagination = meta?.pagination;
    if (pagination?.pageCount === 1) {
      return [];
    }
    return (
      meta?.pagination &&
      [...Array(pagination.pageCount)].map((_, index) => {
        const PAGE = index + 1;
        return (
          <PaginationButton
            onClick={() => {
              setCurrentPage(PAGE);
            }}
            active={PAGE === currentPage}
            value={PAGE}
            key={"pagination-button-" + PAGE}
          />
        );
      })
    );
  };
  const MemorizedButtons = useMemo(createPaginationButtons, [
    currentPage,
    meta?.pagination,
    setCurrentPage,
  ]);

  return (
    <Container>
      <div className="body my-8">
        <div className="grid gap-8 grid-cols-[repeat(auto-fill,minmax(300px,1fr))] auto-rows-min pt-4">
          {resultData && resultData?.length ? (
            resultData.map((data, index) => {
              const reports = data?.attributes;
              const categoryAttributes =
                reports?.report_category?.data?.attributes;
              return (
                <SubResult
                  key={"result-component-" + index}
                  topic={reports?.title}
                  category={categoryAttributes?.title}
                  date={reports?.createdAt}
                  imgSrc={reports?.image?.data?.attributes?.url}
                  external={true}
                  link={reports?.file?.data?.attributes?.url}
                />
              );
            })
          ) : (
            <h1 className="flex justify-start text-2xl font-bold my-2">
              No Result Found
            </h1>
          )}
        </div>
        <div className="flex items-center justify-center gap-2 my-4">
          {MemorizedButtons}
          {meta?.pagination?.pageCount > 1 && (
            <PaginationButton
              value={"Next"}
              onClick={() => {
                if (currentPage < meta?.pagination?.pageCount)
                  setCurrentPage((state) => state + 1);
              }}
            />
          )}
        </div>
      </div>
    </Container>
  );
};

export default React.memo(React.forwardRef(ReportResultComponent));
